export default "__VITE_ASSET__BiuE1QiW__"